import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'overview',
      component: () => import('../views/TheOverview.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/TheLogin.vue'),
      meta: {
        auth: false,
      },
    },
    {
      path: '*',
      name: 'not-found',
      component: () => import('../views/TheNotFound.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (!store.getters['auth/check']) {
      return next({ name: 'login' });
    }

    return next();
  }

  return next();
});

export default router;
